import React from 'react';
import PersonVideos from 'containers/pages/persons/PersonVideos';

const PersonVideosTab = () => {
  return <PersonVideos />;
};

export default PersonVideosTab;
